import { APIResponse } from '../../../@types/api-response';

export enum PaginationNextType {
  Personal = 'PERSONAL',
  Group = 'Group',
}

export interface Pagination {
  next_cursor: string;
  next_type: PaginationNextType;
}

export enum TargetType {
  Unspecified = 'TARGET_TYPE_UNSPECIFIED',
  ChatRoom = 'TARGET_TYPE_CHATROOM',
  User = 'TARGET_TYPE_USER',
}

export interface Target {
  id: number;
  type: TargetType;
  shortened_name: string;
  name: string;
  description: string;
  avatar_url: string;
  is_verified: boolean;
  is_autoshare_active: boolean;
  is_share_value: boolean;
  is_shared?: boolean;
}

export interface ShareTradeTargetResponse {
  targets: Target[];
  pagination: Pagination;
}

export interface ShareTradeTargetParams {
  limit: number;
  keyword?: string;
  cursor?: string;
  initialLoad?: boolean;
}

export type UpdateTargetResponse = APIResponse;

export interface UpdateTargetRequestBody {
  id: number;
  type: TargetType;
  is_active: boolean;
}
